import { MascotPortrait } from "@/components/Mascot";
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const steps = [
  ["The journey", "The Shadowfang hold wolves prisoner across Frostpine. Pick a glowing stop on the map. Paths split, so choose your route. Dens heal you fully and become your checkpoint."],
  ["Read the intent", "Above every enemy is its next move. Heavy attacks are marked in red. Guard to halve them."],
  ["Spirit & skills", "Every turn gives 1 Spirit (max 5). Howl and Guard give 1 extra. Skills spend Spirit for big effects."],
  ["Falling", "If you fall, you return to your last den. Revive tokens or credits let you rise on the spot. NFT holders get extra help."],
];

export default function Tutorial({ open, onDone }) {
  const [i, setI] = useState(0);
  const finish = async () => { await api.post("/game/tutorial/done").catch(() => {}); onDone(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && finish()}>
      <DialogContent aria-describedby={undefined} data-testid="tutorial-dialog" className="glass max-w-md">
        <DialogHeader>
          <p className="text-[11px] font-mono-game text-sky-300">HUNTING LESSON {i + 1}/{steps.length}</p>
          <div className="flex gap-4 items-start pt-1" key={i}>
            <MascotPortrait size="w-16 h-16" className="mt-1" />
            <div className="rise">
              <p data-testid="tutorial-guide-name" className="text-[11px] font-mono-game text-amber-300">KING WOLF SAYS</p>
              <DialogTitle className="font-display text-2xl text-amber-100">{steps[i][0]}</DialogTitle>
              <DialogDescription className="text-slate-300 leading-relaxed pt-2">{steps[i][1]}</DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="flex justify-between items-center pt-4">
          <button data-testid="tutorial-skip-btn" onClick={finish} className="text-sm text-slate-500 hover:text-slate-300">Skip</button>
          {i < steps.length - 1
            ? <button data-testid="tutorial-next-btn" onClick={() => setI(i + 1)} className="ember-btn px-6 py-2 rounded-full text-sm">NEXT</button>
            : <button data-testid="tutorial-finish-btn" onClick={finish} className="ember-btn px-6 py-2 rounded-full text-sm">BEGIN</button>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
